/**
 * Turns a marketplace search term into the `/shop/s/<slug>` path segment.
 *
 * Only for search terms (typed query, PLP/PDP tags). Category, department, CYO and PDP product
 * slugs keep using `sanitizePathname`.
 *
 * Letters (`\p{L}`) and numbers (`\p{N}`) stay, including umlauts. Everything else becomes `-`,
 * consecutive hyphens collapse, then leading/trailing hyphens are stripped. Lowercased so mixed-case
 * URLs redirect onto one canonical slug. Percent-encoding is left to `getPathname`.
 */
export const slugifySearchTerm = (input: string): string =>
  input
    .toLowerCase()
    .replace(/[^\p{L}\p{N}-]+/gu, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

/** H1 / search-box form: the slug with hyphens shown as spaces (`18-geburtstag` → `18 geburtstag`). */
export const displaySearchTerm = (input: string): string =>
  slugifySearchTerm(input).replaceAll('-', ' ');
